const EyeIcon = ({
  className,
  fill = '#E8FFFF',
  width = '33',
  height = '32',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_69_851"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="33"
        height="32"
      >
        <rect x="0.6604" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_69_851)">
        <path
          d="M16.6604 21.3333C18.327 21.3333 19.7437 20.75 20.9104 19.5833C22.077 18.4167 22.6604 17 22.6604 15.3333C22.6604 13.6667 22.077 12.25 20.9104 11.0833C19.7437 9.91668 18.327 9.33334 16.6604 9.33334C14.9937 9.33334 13.577 9.91668 12.4104 11.0833C11.2437 12.25 10.6604 13.6667 10.6604 15.3333C10.6604 17 11.2437 18.4167 12.4104 19.5833C13.577 20.75 14.9937 21.3333 16.6604 21.3333ZM16.6604 18.9333C15.6604 18.9333 14.8104 18.5833 14.1104 17.8833C13.4104 17.1833 13.0604 16.3333 13.0604 15.3333C13.0604 14.3333 13.4104 13.4833 14.1104 12.7833C14.8104 12.0833 15.6604 11.7333 16.6604 11.7333C17.6604 11.7333 18.5104 12.0833 19.2104 12.7833C19.9104 13.4833 20.2604 14.3333 20.2604 15.3333C20.2604 16.3333 19.9104 17.1833 19.2104 17.8833C18.5104 18.5833 17.6604 18.9333 16.6604 18.9333ZM16.6604 25.3333C13.4159 25.3333 10.4604 24.4278 7.79371 22.6167C5.12705 20.8056 3.19371 18.3778 1.99371 15.3333C3.19371 12.2889 5.12705 9.86112 7.79371 8.05001C10.4604 6.2389 13.4159 5.33334 16.6604 5.33334C19.9048 5.33334 22.8604 6.2389 25.527 8.05001C28.1937 9.86112 30.127 12.2889 31.327 15.3333C30.127 18.3778 28.1937 20.8056 25.527 22.6167C22.8604 24.4278 19.9048 25.3333 16.6604 25.3333ZM16.6604 22.6667C19.1715 22.6667 21.477 22.0056 23.577 20.6833C25.677 19.3611 27.2826 17.5778 28.3937 15.3333C27.2826 13.0889 25.677 11.3056 23.577 9.98334C21.477 8.66112 19.1715 8.00001 16.6604 8.00001C14.1493 8.00001 11.8437 8.66112 9.74371 9.98334C7.64371 11.3056 6.03816 13.0889 4.92705 15.3333C6.03816 17.5778 7.64371 19.3611 9.74371 20.6833C11.8437 22.0056 14.1493 22.6667 16.6604 22.6667Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default EyeIcon
